import React from "react";
import Steps from "../Payment/Steps";

export default function JoinNow() {
  return <Steps />;
}
